<template>
  <div>
    <h1>Account</h1>
    Welcome {{ userFirstName }},<br />
    Logged in as: {{ userEmail }}.<br /><br />
    Created on: {{ createdStr }}<br  />
    Last login: {{ lastLoginStr }}<br  />
    <span v-if="hasValidSubscription">
      Subscription expires: {{ subscriptionExpiresStr }}
    </span>
    <span v-else>
      Subscription expired!
    </span>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'account',
  computed: {
    ...mapState({
      userCreated: (state) => state.user.created,
      userEmail: (state) => state.user.email,
      userFirstName: (state) => state.user.firstName,
      userFullName: (state) => state.user.fullName,
      userLastLogin: (state) => state.user.lastLogin,
      userLastName: (state) => state.user.lastName,
      userSubscriptionExpires: (state) => state.user.subscriptionExpires,
    }),
    createdStr() {
      var d = new Date(this.userCreated);
      return d.toLocaleString();
    },
    lastLoginStr() {
      var d = new Date(this.userLastLogin);
      return d.toLocaleString();
    },
    subscriptionExpiresStr() {
      var d = new Date(this.userSubscriptionExpires);
      return d.toLocaleString();
    },
    hasValidSubscription() {
      var d = new Date(this.userSubscriptionExpires);
      var now = new Date();
      return d >= now;
    },
  },
};
</script>
